import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";

export const unauthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const token = localStorage.getItem("accessToken");

  if (token) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
